import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-[#E3DED2] bg-[#FCFCFA]">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-14">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-8">
          <div>
            <Logo variant="dark" className="h-12" />
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-[#6E6359]">
            <Link to="/club-etiquette" data-testid="footer-etiquette" className="hover:text-[#48020C] transition-colors">Club Etiquette</Link>
            <Link to="/termos" data-testid="footer-terms" className="hover:text-[#48020C] transition-colors">Termos de Utilização e Membership</Link>
            <Link to="/privacidade" data-testid="footer-privacy" className="hover:text-[#48020C] transition-colors">Política de Privacidade</Link>
          </nav>
        </div>
        <p className="text-xs text-[#6E5F58] mt-10">By joining the Club, you're joining the community. Take care of it. ✦</p>
      </div>
    </footer>
  );
}
